
import React from "react";
import { CalculatorInput } from "@/components/ui/calculator-input";
import StepCard from "../StepCard";
import { Info } from "lucide-react";

interface PressureAdvanceMeasurementInputProps {
  pressureAdvanceStart: string;
  onPressureAdvanceStartChange: (value: string) => void;
  pressureAdvanceStep: string;
  onPressureAdvanceStepChange: (value: string) => void;
  measuredHeight: string;
  onMeasuredHeightChange: (value: string) => void;
  onNext: () => void;
  onPrevious: () => void;
}

const PressureAdvanceMeasurementInput = ({
  pressureAdvanceStart,
  onPressureAdvanceStartChange,
  pressureAdvanceStep,
  onPressureAdvanceStepChange,
  measuredHeight,
  onMeasuredHeightChange,
  onNext,
  onPrevious
}: PressureAdvanceMeasurementInputProps) => {
  const canProceed = pressureAdvanceStart && pressureAdvanceStep && measuredHeight;

  return (
    <StepCard 
      title="Measurement and Settings"
      onNext={canProceed ? onNext : undefined}
      onPrevious={onPrevious}
      showPrevious
    >
      <div className="space-y-6">
        <div className="bg-blue-50 dark:bg-blue-950 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
          <h4 className="font-semibold text-blue-800 dark:text-blue-200 mb-3">
            Measurement Instructions
          </h4>
          <ol className="list-decimal list-inside space-y-2 text-blue-700 dark:text-blue-300">
            <li>Examine each corner of the print and mark the height that yields the best overall result.</li>
            <li>Measure this height with a ruler (in millimeters).</li>
          </ol>
        </div>

        <div className="space-y-4">
          <CalculatorInput
            label="Input the PA Start Value"
            placeholder=""
            value={pressureAdvanceStart}
            onChange={onPressureAdvanceStartChange}
            id="pressure-advance-start"
            allowNegative={false}
          />

          <CalculatorInput
            label="Input the PA Step Value"
            placeholder=""
            value={pressureAdvanceStep}
            onChange={onPressureAdvanceStepChange}
            id="pressure-advance-step"
            allowNegative={false}
          />

          <CalculatorInput
            label="Input the best height (mm)"
            placeholder=""
            value={measuredHeight}
            onChange={onMeasuredHeightChange}
            id="measured-height"
            autoFocus
            allowNegative={false}
          />
        </div>

        {!canProceed && (
          <div
            className="flex items-start gap-3 bg-blue-50 dark:bg-blue-950 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mt-2"
            role="alert"
          >
            <Info className="h-5 w-5 text-blue-700 dark:text-blue-300 mt-0.5" aria-hidden="true" />
            <div className="text-sm text-blue-800 dark:text-blue-200">
              Please fill in all fields to continue
            </div>
          </div>
        )}
      </div>
    </StepCard>
  );
};

export default PressureAdvanceMeasurementInput;
